export const DOMAIN_SUPPORT = "SUPPORT";
